import React, { useContext, useEffect, useState } from 'react'
import { Loading } from '@guillotinaweb/react-gmi'
import {
  Affix,
  Button,
  Empty,
  InputNumber,
  Radio,
  Space,
  Table,
  message,
  Spin,
  Tag,
  Input,
  Form,
  Select,
  Checkbox,
  Modal,
} from 'antd'

import { ErpClientContext } from '../../../services/erp'
import { ProductSelector } from '../../../components/product-selector'
import { getOfferPrice, getTotalStock } from '../../../utils'

import './style.css'
import 'antd/dist/antd.css'

function FormToAddProductNoCatalog({ onFinish }) {
  const [data, setData] = useState()
  const erp = useContext(ErpClientContext)
  const { Option } = Select

  useEffect(() => {
    init()
  }, []) // Carga al iniciar
  async function init() {
    const res = await erp.getProductsOutCatalog()
    setData(res)
  }
  if (!data) return 'Loading'

  return (
    <Form onFinish={onFinish} layout="inline">
      <Form.Item
        name="producto"
        label="Product out catalog: "
        rules={[{ required: true, message: 'Please select the product!' }]}
      >
        <Select
          showSearch
          style={{
            width: 340,
          }}
        >
          {data.map((item) => (
            <Option key={item[0]} value={item}>
              {item[1]}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label="Quantity"
        name="cantidad"
        rules={[{ required: true, message: 'Please enter the quantity!' }]}
      >
        <InputNumber style={{ width: '70px' }} min={0} />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Add Product out Catalog
        </Button>
      </Form.Item>
    </Form>
  )
}

export function OrderEdit({ id }) {
  const erp = useContext(ErpClientContext)
  const [saving, setSaving] = useState(false)
  const [originalOrder, setOriginalOrder] = useState()
  const [order, setOrder] = useState()
  const [forced, setForced] = useState(false)
  const [changePrice, setChangePrice] = useState(false)
  const [ignoreStockRestrictions, setIgnoreStockRestrictions] = useState(false)
  const [loading, setLoading] = useState(false)
  const ids = new Set(order?.lines?.map?.((l) => l.id_producto))
  const currency = order?.currency || 'EUR'
  const sumPrice = (acc, l) =>
    acc + (l.base_imponible + l.base_imponible * l.tipo_iva) * l.cantidad
  const totalOriginalProducts = originalOrder?.lines?.reduce?.(sumPrice, 0)
  const rest = totalOriginalProducts - originalOrder?.precio_total
  const totalOld = originalOrder?.precio_total
  const total = order?.lines?.reduce?.(sumPrice, 0) - rest

  const formatter = new Intl.NumberFormat(
    currency === 'EUR' ? 'es-ES' : 'en-UK',
    {
      style: 'currency',
      currency,
    }
  )

  const onFinish = (value) => {
    const [id_producto, nombre, precio] = value.producto
    const cantidad = value.cantidad
    const lines = order.lines.slice()
    const newLine = {
      id_producto,
      nombre,
      isNew: true,
      outCatalog: true,
      new_price: precio,
      new_taxes: lines[0].new_taxes,
      base_imponible: precio,
      tipo_iva: 0.21,
      old_price: 0,
      old_taxes: lines[0].old_taxes,
      cantidad,
    }
    setOrder((o) => ({ ...o, lines: [...o.lines, newLine] }))
  }

  function checkProductsElasticsearch(order) {
    erp.checkProductsElasticsearch({
      ids_products: order.lines.map((l) => l.id_producto),
    })
  }

  useEffect(loadOrder, [id])
  function loadOrder() {
    setLoading(true)
    erp.fetchOrder(id).then((data) => {
      setOrder(data)
      setOriginalOrder(data)
      checkProductsElasticsearch(data)
      setLoading(false)
    })
  }

  function onEditProduct(prods, suggestions, index) {
    const ref = prods[prods.length - 1]
    const prod = suggestions.find((p) => p.ref === ref)
    const lines = order.lines.slice() // copy

    if (!prod) return

    const prodData = {
      id_producto: ref,
      nombre: prod.nombre,
      formato: prod.option.capacidad,
      grupo: prod.id,
      base_imponible: prod.option.precio_sin_impuestos,
      tipo_iva: prod.option.impuestos,
      old_price: lines?.[index]?.old_price ?? prod.option.precio_sin_impuestos,
      old_taxes: lines?.[index]?.old_taxes ?? prod.option.impuestos,
      new_price: prod.option.precio_sin_impuestos,
      option: prod.option,
      new_taxes: prod.option.impuestos,
      stock: getTotalStock(prod.option),
    }

    // Put again the original line product
    if (ref === originalOrder?.lines?.[index]?.id_producto) {
      lines[index] = { ...originalOrder.lines[index] }
      // Add new line
    } else if (!lines[index]) {
      lines.push({
        ...prodData,
        cantidad: 1,
        isNew: true,
      })
      // Update line
    } else {
      lines[index] = {
        ...lines[index],
        ...prodData,
      }
    }

    setOrder((o) => ({ ...o, lines }))
  }

  function onEditQuantity(quantity, index) {
    setOrder((o) => ({
      ...o,
      lines: o.lines.map((l, i) => {
        if (i === index) {
          return { ...l, cantidad: quantity }
        }
        return l
      }),
    }))
  }

  async function onSave() {
    setSaving(true)
    const res = await erp.updateOrderProducts(order, {
      product_lines: order.lines
        .filter((l) => l.cantidad > 0)
        .map((l) => ({
          id_producto: l.id_producto,
          cantidad: l.cantidad,
        })),
      change_price: changePrice,
      forced: forced,
      ignore_stock_restrictions: ignoreStockRestrictions,
    })
    if (res.status >= 300) {
      setSaving(false)
      const errorMsg = await res
        .json()
        .catch(() => 'An error has ocurred while saving the order')
      message.error(errorMsg?.message || errorMsg)
      return
    }
    const responseJson = await res.json()
    if (responseJson?.pack_products?.length > 0) {
      Modal.info({
        title: 'Producto/s de un pack con descuento, REVISAR EN DETALLE PEDIDO',
        content: (
          <div>
            {responseJson.pack_products.map((product) => (
              <p>{product}</p>
            ))}
          </div>
        ),
        onOk() {
          window.location.href = `/administracion/pedidos/detalle_pedido.html?id_pedido=${order.id_pedido}`
        },
        width: '35%',
      })
    } else {
      window.location.href = `/administracion/pedidos/detalle_pedido.html?id_pedido=${order.id_pedido}`
    }
  }

  return (
    <div
      className="container"
      style={{ backgroundColor: '#fff', padding: '30px' }}
    >
      <Affix offsetTop={10}>
        <div
          className="level"
          style={{ padding: '10px', backgroundColor: 'white' }}
        >
          <div className="level-left">
            <h2 className="title is-size-5">Edit order #{id}</h2>
          </div>
          <div className="level-right is-size-7">
            <Button disabled={saving || !order} type="primary" onClick={onSave}>
              Save
            </Button>
          </div>
        </div>
      </Affix>
      {(() => {
        if (saving)
          return (
            <Spin tip="Saving...">
              <div style={{ width: '100%', height: '100vh' }} />
            </Spin>
          )
        if (loading) return <Loading />
        if (!loading && !order) return <Empty />
        return (
          <>
            <div style={{ margin: '20px 0', fontSize: 14 }}>
              <h2 style={{ marginBottom: 10 }}>
                Is this a <b>voluntary</b> or <b>forced</b> product change?
              </h2>
              <Radio.Group
                onChange={(e) => setForced(e.target.value)}
                value={forced}
              >
                <Space direction="vertical">
                  <Radio value={false}>
                    <b>Voluntary:</b> The customer has requested a modification
                    or an unpublished product, etc.
                  </Radio>
                  <Radio value={true}>
                    <b>Forced:</b> It has been impossible to find any of the
                    products requested by the customer, and the customer has
                    accepted a change or reduced the order.
                  </Radio>
                </Space>
              </Radio.Group>
            </div>
            <div style={{ margin: '20px 0', fontSize: 14 }}>
              <h2 style={{ marginBottom: 10 }}>
                Do you want to <b>keep the prices</b> at the time of the order,
                or do you want to update the prices?
              </h2>
              <Radio.Group
                onChange={(e) => {
                  const change = e.target.value
                  const prefix = change ? 'new_' : 'old_'
                  setChangePrice(change)
                  setOrder((o) => ({
                    ...o,
                    lines: o.lines.map((l) => ({
                      ...l,
                      base_imponible: l[`${prefix}price`],
                      tipo_iva: l[`${prefix}taxes`],
                    })),
                  }))
                }}
                value={changePrice}
              >
                <Space direction="vertical">
                  <Radio value={false}>
                    <b>Keep</b> original prices
                  </Radio>
                  <Radio value={true}>
                    <b>Update</b> to current prices
                  </Radio>
                </Space>
              </Radio.Group>
            </div>

            <div style={{ margin: '20px 0', fontSize: 14 }}>
              <h2 style={{ marginBottom: 10 }}>
                Add products by id out of catalogue (Boxes, Joker...)
              </h2>
              <FormToAddProductNoCatalog onFinish={onFinish} />
            </div>

            <Table
              dataSource={[...(order?.lines || []), {}]}
              pagination={false}
              style={{ maxWidth: '900px' }}
              rowClassName={(line, index) => {
                const { oldPriceLine, priceLine } = getPriceLine(
                  line,
                  (originalOrder?.lines || [])[index]
                )
                if (line.isNew) return 'price-changed'
                return oldPriceLine === priceLine ||
                  index === order.lines.length
                  ? ''
                  : 'price-changed'
              }}
              columns={[
                {
                  title: 'Product',
                  dataIndex: 'nombre',
                  key: 'id_producto',
                  width: 350,
                  render(name, line, index) {
                    const newID =
                      line.id_producto &&
                      line.id_producto !==
                        originalOrder.lines[index]?.id_producto
                    return (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8,
                        }}
                      >
                        {newID && (
                          <div
                            style={{
                              textDecoration: 'line-through',
                              marginRight: 10,
                            }}
                          >
                            {originalOrder.lines[index]?.id_producto}
                          </div>
                        )}
                        <ProductSelector
                          products={line.id_producto ? [line.id_producto] : []}
                          type="refs"
                          state={['new_product', 'selling', 'notavailable']}
                          closable={false}
                          placeholder="Add a new product"
                          disabledIds={ids}
                          onChange={(prods, suggestions) =>
                            onEditProduct(prods, suggestions, index)
                          }
                          disabled={line.outCatalog}
                        />
                      </div>
                    )
                  },
                },
                {
                  title: 'Stock',
                  dataIndex: 'stock',
                  key: 'stock',
                  render(stock, line, index) {
                    // Línea original correspondiente a este índice
                    const originalLine = (originalOrder?.lines || [])[index]

                    // Solo sumamos cantidad original si es el mismo producto
                    const sameProduct =
                      originalLine &&
                      originalLine.id_producto === line.id_producto

                    const originalQty = sameProduct
                      ? originalLine.cantidad || 0
                      : 0

                    // Stock libre:
                    // - Si tenemos option, usamos getTotalStock(option) (availability, etc.)
                    // - Si no, caemos a line.stock como último recurso
                    let freeStock = 0
                    if (line.option) {
                      freeStock = getTotalStock(line.option || {})
                    } else if (typeof line.stock === 'number') {
                      freeStock = line.stock
                    }

                    // Lo que mostramos como "stock total disponible" para este pedido:
                    // stock libre + lo que ya estaba reservado en este pedido
                    return freeStock + originalQty
                  },
                },
                {
                  title: 'Quantity',
                  dataIndex: 'cantidad',
                  key: 'cantidad',
                  render(quantity, line, index) {
                    // Línea original correspondiente a este índice
                    const originalLine = (originalOrder?.lines || [])[index]

                    // Solo sumamos cantidad original si es el mismo producto
                    const sameProduct =
                      originalLine &&
                      originalLine.id_producto === line.id_producto

                    const originalQty = sameProduct
                      ? originalLine.cantidad || 0
                      : 0

                    // Stock libre:
                    // - Si tenemos option, usamos getTotalStock(option) (availability, etc.)
                    // - Si no, caemos a line.stock como último recurso
                    let freeStock = 0
                    if (line.option) {
                      freeStock = getTotalStock(line.option || {})
                    } else if (typeof line.stock === 'number') {
                      freeStock = line.stock
                    }

                    // Máximo permitido:
                    // stock libre + lo que ya estaba en este pedido,
                    // pero SOLO si NO se ha marcado "Ignorar restricciones de stocks"
                    const max =
                      !ignoreStockRestrictions && line.option?.ultimas_unidades
                        ? freeStock + originalQty
                        : false

                    return (
                      <InputNumber
                        disabled={!line.id_producto}
                        value={quantity ?? 1}
                        max={max}
                        onChange={(v) => onEditQuantity(v, index)}
                        min={0}
                      />
                    )
                  },
                },
                {
                  title: 'Unitary price',
                  dataIndex: 'new_price',
                  key: 'new_price',
                  width: 250,
                  render(price, line, index) {
                    if (price === undefined) return '-'

                    let color = 'green'
                    const { offer, priceLine, oldPriceLine } = getPriceLine(
                      { ...line, cantidad: 1 },
                      {
                        ...((originalOrder?.lines || [])[index] || line),
                        cantidad: 1,
                      }
                    )

                    if (priceLine < oldPriceLine) color = 'red'

                    return (
                      <>
                        {priceLine !== oldPriceLine && (
                          <span
                            style={{
                              textDecoration: 'line-through',
                              marginRight: 10,
                            }}
                          >
                            {formatter.format(oldPriceLine)}
                          </span>
                        )}
                        {priceLine === oldPriceLine ? (
                          formatter.format(oldPriceLine)
                        ) : (
                          <Tag color={color}>{formatter.format(priceLine)}</Tag>
                        )}
                        {offer === priceLine && color === 'red' && (
                          <Tag color="red">Offer</Tag>
                        )}
                      </>
                    )
                  },
                },
                {
                  title: 'Order price',
                  dataIndex: 'base_imponible',
                  key: 'base_imponible',
                  width: 250,
                  render(price, line, index) {
                    if (price === undefined) {
                      let color = totalOld > total ? 'red' : 'green'
                      if (total === totalOld) color = 'black'

                      return (
                        <b>
                          {`TOTAL: `}
                          {total !== totalOld && (
                            <span style={{ textDecoration: 'line-through' }}>
                              {formatter.format(totalOld)}
                            </span>
                          )}
                          <Tag color={color} style={{ marginLeft: 10 }}>
                            {formatter.format(total)}
                          </Tag>
                        </b>
                      )
                    }
                    const { oldPriceLine, priceLine } = getPriceLine(
                      line,
                      (originalOrder?.lines || [])[index]
                    )
                    const color = oldPriceLine > priceLine ? 'red' : 'green'

                    if (priceLine === oldPriceLine)
                      return formatter.format(priceLine)

                    return (
                      <>
                        <span style={{ textDecoration: 'line-through' }}>
                          {formatter.format(oldPriceLine)}
                        </span>
                        <Tag color={color} style={{ marginLeft: 10 }}>
                          {formatter.format(priceLine)}
                        </Tag>
                      </>
                    )
                  },
                },
              ]}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                disabled={saving || !order}
                type="primary"
                onClick={onSave}
              >
                Save
              </Button>
            </div>
            <div
              style={{
                marginTop: 64, // equivalente aproximado a <br><br>
                marginLeft: 0,
              }}
            >
              <Checkbox
                checked={ignoreStockRestrictions}
                onChange={(e) => setIgnoreStockRestrictions(e.target.checked)}
              >
                Ignorar restricciones de stocks
              </Checkbox>
            </div>
          </>
        )
      })()}
    </div>
  )
}

function getPriceLine(line, oldLine = line) {
  const price = line.base_imponible
  const oldPrice = oldLine.base_imponible
  const oldPriceLine =
    (oldPrice + oldPrice * oldLine.tipo_iva) * oldLine.cantidad

  let offer = getOfferPrice(line.cantidad, line.option)

  if (offer) offer = offer + offer * line.tipo_iva

  const priceLine =
    line.base_imponible === line.new_price && offer
      ? offer
      : (price + price * line.tipo_iva) * line.cantidad

  return { oldPriceLine, priceLine, offer }
}
